module.exports = __webpack_public_path__ + "_assets/img/LimitedTimeMission-Stpes.cece6eb8.svg";